import React from 'react';
import './CTA.css';

const CTA = () => {
  return (
    <div className='gpt3__cta'>
      <div className="gpt3__cta-content">
        <p>Request Early Access</p>
        <h3>Register today and start exploring the endless possibilities.</h3>
      </div>
      <div className="gpt3__cta-button">
        <button type='button'>Get Started</button>
      </div>
    </div>
  )
}

export default CTA